import { GraphQLClient } from "graphql-request";

import Config from "~/config";
import offlineRequestMiddleware from "~/helpers/offline/offlineRequestMiddleware";
import getHeaders from "~/services/graphqlHeaders";

const adminClient = new GraphQLClient(Config.adminGraphqlEndpoint, {
	credentials: "omit",
	headers: () => getHeaders(),
	mode: "cors",
	requestMiddleware: offlineRequestMiddleware
});

export default adminClient;
